import { render, staticRenderFns } from "./QChipFases.vue?vue&type=template&id=4f3b306e&scoped=true"
import script from "./QChipFases.vue?vue&type=script&lang=js"
export * from "./QChipFases.vue?vue&type=script&lang=js"
import style0 from "./QChipFases.vue?vue&type=style&index=0&id=4f3b306e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3b306e",
  null
  
)

export default component.exports